<template>
  <fragment>
    <div class="confectionModal">
      <div class="confectionModal-top">
        <img
          class="confectionModal-image img-responsive"
          alt="envelope example"
          :src="image"
          width="400px"
        >
      </div>

      <div class="confectionModal-content">
        <h2 class="confectionModal-title">Świąteczny pakiet promocji</h2>
        <section class="confectionModal-descriptions">
          <p>
            Z kartami Pluxee Twoi pracownicy mogą otrzymać pakiety promocji, które znacząco zwiększają realną wartość upominku.
            Dzięki nim pieniądze przekazane pracownikom na kartach i kuponach Pluxee mają w rzeczywistości o wiele wyższą wartość.
          </p>
        </section>
        <section>
          <p>
            <a href="https://www.pluxee.pl/uzytkownik/pakiet-promocji/" target="_blank" rel="noopener">
              Dowiedz się o korzyściach, jakie niesie pakiet promocji dla Twoich Pracowników
            </a>
          </p>
        </section>
      </div>
    </div>
  </fragment>
</template>

<script>
export default {
  name: 'NDEPromoPacketModal',
  props: {
    image: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>

</style>
